import { sanitizeString } from "@/helpers/SanitizeHelper";
import { tagEvents } from "./events";
import { EventProps } from "./eventTypes";

export const executeGaEvent = (eventProps: EventProps) => {
  const { event = "clique", eventName = "" } = eventProps;

  const win = window as any;
  const logPrd = (message: unknown) => {
    if (process.env.VUE_APP_ENV_KEY !== "PRD") {
      console.log(message);
    }
  };

  if (eventName !== "") {
    logPrd(tagEvents[eventName]);
    win.dataLayer.push(tagEvents[eventName]);
  } else {
    const { custom_section, custom_title } = eventProps;
    const eventObject = {
      ...eventProps,
      event,
    };

    if (eventObject.custom_section && eventObject.custom_section !== "") {
      eventObject.custom_section = sanitizeString(String(custom_section));
    }

    if (eventObject.custom_title && eventObject.custom_title !== "") {
      eventObject.custom_title = sanitizeString(String(custom_title));
    }

    logPrd(eventObject);
    win.dataLayer.push({ ...eventObject });
  }
};
